export const characters = [
    {
      name: "Everlyn Sterling",
      image: "/images/AWH/everlyn-char.png", // Replace with your character image path
      relatives: [
        "Emilia Sterling (mother)",
        "Andrew Sterling (father)",
        "Clarissa Sterling (grandmother)",
      ],
      friends: [
        "Quinn (Best Friend)",
        "Finley (Determinant)",
        "Blue Spirit (Determinant)",
      ],
      enemies: [
        "Blue Spirit (Determinant)",
      ],
      alignment: "Good or bad (Determinant)",
      strengths: "Problem-solving, programming",
      weaknesses: "Relies on taste for identification of objects",
      description: `Everlyn Sterling is the favorite (only!) granddaughter of Clarissa Sterling.Having anxiety over finding her next job, Everlyn takes up her 
      grandmother up in northern Pacifica on taking care of the Lunabelle mansion. Little does she 
      know that this "break" will be riddled with taunts from a mean spirit.`,
    },
    {
      name: "Melinda (Mel)",
      image: "/images/AWH/mel-char.png", // Replace with another character image path
      relatives: ["*Grace Lunabelle (mother)*","*Charles Lunabelle (father)*"],
      friends: ["Everlyn Sterling", "*Emerson Ashford (partner)*", "*Clara Sterling (best friend)*"], // Placeholder for friends
      enemies: ["*Emerson Ashford (formerly)*"], // Placeholder for enemies
      alignment: "Good",
      strengths: "Plowing snow, dusting, knowing historical facts", // Placeholder for strengths
      weaknesses: "Clumsiness", // Placeholder for weaknesses
      description: `A sweet, hardworking caretaker who befriends Everlyn. Mel is quite fascinated with the history of
      the Lunabelle mansion and helps Everlyn out to uncover the secrets behind this mansion.`,
    },
    {
        name: "Finley Hawthorne",
        image: "/images/AWH/finley-char.png", // Replace with another character image path
        relatives: ["Unknown parents"],
        friends: ["Everlyn Sterling (determinant)"], // Placeholder for friends
        enemies: ["Everlyn Sterling (determinant)"], // Placeholder for enemies
        alignment: "Neutral",
        strengths: "Clever quips, telling people off", // Placeholder for strengths
        weaknesses: "Successful interviews, cold mansion drafts", // Placeholder for weaknesses
        description: `A young woman with a tough exterior. Like Everlyn, she is also struggling to find a job, 
        and due to this stress, she tends to lash out at everyone around her.`,
    },
    // Add more characters as needed
  ];
  